<template>
  <div class="order-table">
    <div v-for="(detailsItem,index) in purchaseDetailsList" :key="index" class="order-table-body">
      <!--表格thead开始-->
      <div class="order-table-row table-thead">
        <div class="order-column-box">
          <div class="order-table-row-left">
            <div class="order-table-column">
              <div class="order-table-cell cell-label"></div>
              <div
                @click="showSupplierInfo(detailsItem.mainSupplierName,detailsItem.mainlinkMan,detailsItem.maincontact,detailsItem.mainwebSite,detailsItem.mainaddCondition)"
                class="order-table-cell cell-value"
              >
                {{detailsItem.mainSupplierName}}
                <div class="more-box"></div>
              </div>
              <div
                @click="showSupplierInfo(detailsItem.firsContrastSupplierName,detailsItem.firsContrastLinkMan,detailsItem.firsContrastContact,detailsItem.firsContrastWebSite,detailsItem.firsContrastAddCondition)"
                class="order-table-cell cell-value"
              >
                {{detailsItem.firsContrastSupplierName}}
                <div class="more-box"></div>
              </div>
              <div
                @click="showSupplierInfo(detailsItem.secondContrastSupplierName,detailsItem.secondContrastLinkMan,detailsItem.secondContrastContact,detailsItem.secondContrastWebSite,detailsItem.secondContrastAddCondition)"
                class="order-table-cell cell-value"
              >
                {{detailsItem.secondContrastSupplierName}}
                <div class="more-box"></div>
              </div>
            </div>
          </div>
          <div class="order-table-row-right"></div>
        </div>
      </div>
      <!--表格thead结束-->
      <!--表格body开始-->
      <div>
        <div class="order-table-row">
          <div class="order-column-box">
            <div class="order-table-row-left">
              <div class="goodsname">{{detailsItem.goodsName}}</div>
            </div>
            <div class="order-table-row-right">数量</div>
          </div>
        </div>
        <div class="order-table-row">
          <div class="order-column-box">
            <div class="order-table-row-left">
              <div class="order-table-column">
                <div class="order-table-cell cell-label">单价</div>
                <div
                  class="order-table-cell main-value cell-value"
                >{{detailsItem.mainSupplierPrice|NumFormat}}</div>
                <div class="order-table-cell cell-value">{{detailsItem.firsContrastSupplierPrice|NumFormat}}</div>
                <div class="order-table-cell cell-value">{{detailsItem.secondContrastSupplierPrice|NumFormat}}</div>
              </div>
              <div class="order-table-column">
                <div class="order-table-cell cell-label">总价</div>
                <div
                  class="order-table-cell main-value cell-value"
                >{{detailsItem.mainSupplierTotalPrice|NumFormat}}</div>
                <div
                  class="order-table-cell cell-value"
                >{{detailsItem.firsContrastSupplierTotalPrice|NumFormat}}</div>
                <div
                  class="order-table-cell cell-value"
                >{{detailsItem.secondContrastSupplierTotalPrice|NumFormat}}</div>
              </div>
            </div>
            <div class="order-table-row-right">{{detailsItem.goodsNumber+detailsItem.goodsUnits}}</div>
          </div>
        </div>
      </div>
      <!--表格body结束-->
    </div>
    <div v-if="supplierInfo.isShow" class="supplier-info-box">
      <div class="supplier-box">
        <div @click="showSupplierInfo" class="co"></div>
        <div class="info-box">
          <div class="supplierName">{{supplierInfo.name}}</div>
          <div class="supplier-info-content">
            <div class="supplier-info-label">联系人</div>
            <div class="supplier-info-value">{{supplierInfo.linkMan}}</div>
          </div>
          <div class="supplier-info-content">
            <div class="supplier-info-label">联系方式</div>
            <div class="supplier-info-value">{{supplierInfo.contact}}</div>
          </div>
          <div class="supplier-info-content">
            <div class="supplier-info-label">网址</div>
            <div class="supplier-info-value">{{supplierInfo.webSite}}</div>
          </div>
          <div class="supplier-info-content">
            <div class="supplier-info-label">选择理由</div>
            <div class="supplier-info-value">{{supplierInfo.addCondition}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      supplierInfo: {
        isShow: false,
        name: "",
        linkMan: "",
        contact: "",
        webSite: "",
        addCondition: ""
      }
    };
  },
  props: {
    purchaseDetailsList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    showSupplierInfo(name, linkMan, contact, webSite, addCondition) {
      if (this.supplierInfo.isShow) {
        this.supplierInfo.isShow = false;
        document.body.style.overflow = "auto";
      } else {
        this.supplierInfo = {
          isShow: true,
          name: name,
          linkMan: linkMan,
          contact: contact,
          webSite: webSite,
          addCondition: addCondition
        };
        document.body.style.overflow = "hidden";
      }
    }
  }
};
</script>
<style lang="less" scoped>
.order-table {
  .order-table-body {
    width: 100%;
    .table-thead {
      border-top: 1px solid #dbdbdb;
      background: #f5f5f5;
      .cell-value {
        display: -webkit-box !important;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        position: relative;
        .more-box {
          width: 0.373333rem;
          height: 0.373333rem;
          position: absolute;
          bottom: 0;
          right: 0;
          background: url("../../../assets/icon/tishi.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .order-table-row {
      border-right: 1px solid #dbdbdb;
      border-left: 1px solid #dbdbdb;
      border-bottom: 1px solid #dbdbdb;
      .order-column-box {
        width: 100%;
        display: flex;
        align-items: center;
        font-size: 0.32rem;
        color: #666666;
        .order-table-row-left {
          flex: 1;
          border-right: 1px solid #dbdbdb;
          .goodsname {
            padding: 0.213333rem 0 0.213333rem 0.266667rem;
          }
          .order-table-column {
            display: flex;
            text-align: center;
            .order-table-cell {
              height: 1.08rem;
              display: flex;
              justify-content: center;
              align-items: center;
              border-top: 1px solid #dbdbdb;
            }
            .cell-label {
              flex: 1;
            }
            .main-value {
              color: #f5a623;
            }
            .cell-value {
              width: 2.16rem;
              border-left: 1px solid #dbdbdb;
            }
          }
          .order-table-column:first-child .order-table-cell {
            border-top: 0;
          }
        }
        .order-table-row-right {
          width: 1.333333rem;
          text-align: center;
        }
      }
    }
  }
  .supplier-info-box {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    background: rgba(0, 0, 0, 0.5);
    .supplier-box {
      width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      .co {
        width: 100%;
        flex: 1;
      }
      .info-box {
        width: 100%;
        height: auto;
        max-height: 90%;
        background: #ffffff;
        border-radius: 0.4rem 0.4rem 0 0;
        padding: 0 0.4rem;
        padding-bottom: 0.4rem;
        .supplierName {
          width: 100%;
          margin-top: 0.666667rem;
          font-size: 0.453333rem;
          font-weight: bold;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          color: #2c2c2c;
        }
        .supplier-info-content {
          width: 100%;
          display: flex;
          font-size: 0.373333rem;
          margin-top: 0.4rem;          
          .supplier-info-label {
            width: 1.8rem;          
            color: #999999;
          }
          .supplier-info-value {
            flex: 1;
            color: #333333;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Share/Table/Order.vue